/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';

/**
 * 
 * @export
 * @interface AdminProductDetailMarketplace
 */
export interface AdminProductDetailMarketplace {
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailMarketplace
     */
    createdAt: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailMarketplace
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailMarketplace
     */
    link: string;
    /**
     * LinkBrokenAt is since when the link no longer leads to a live listing;
     * null while it works or was not checked.
     * @type {string}
     * @memberof AdminProductDetailMarketplace
     */
    linkBrokenAt?: string;
    /**
     * ManagedByEbay: published from the admin; the eBay listing card manages it, the form does not edit it.
     * @type {boolean}
     * @memberof AdminProductDetailMarketplace
     */
    managedByEbay: boolean;
    /**
     * 
     * @type {AdminMarketplaceType}
     * @memberof AdminProductDetailMarketplace
     */
    name: AdminMarketplaceType;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailMarketplace
     */
    price: string;
    /**
     * PriceSyncedAt is when the price was last taken from the marketplace
     * automatically; null when it was set by hand after that.
     * @type {string}
     * @memberof AdminProductDetailMarketplace
     */
    priceSyncedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailMarketplace
     */
    updatedAt: string;
}



export function AdminProductDetailMarketplaceFromJSON(json: any): AdminProductDetailMarketplace {
    return AdminProductDetailMarketplaceFromJSONTyped(json, false);
}

export function AdminProductDetailMarketplaceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductDetailMarketplace {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'id': json['id'],
        'link': json['link'],
        'linkBrokenAt': !exists(json, 'linkBrokenAt') ? undefined : json['linkBrokenAt'],
        'managedByEbay': json['managedByEbay'],
        'name': AdminMarketplaceTypeFromJSON(json['name']),
        'price': json['price'],
        'priceSyncedAt': !exists(json, 'priceSyncedAt') ? undefined : json['priceSyncedAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function AdminProductDetailMarketplaceToJSON(value?: AdminProductDetailMarketplace | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'id': value.id,
        'link': value.link,
        'linkBrokenAt': value.linkBrokenAt,
        'managedByEbay': value.managedByEbay,
        'name': AdminMarketplaceTypeToJSON(value.name),
        'price': value.price,
        'priceSyncedAt': value.priceSyncedAt,
        'updatedAt': value.updatedAt,
    };
}

